<script setup lang="ts">
import { Site, UserScope } from "@soft-db/monitoring-api-client";
import { Button, makeColumnHelper } from "@soft-db/ui";
import AppDataTable from "../common/AppDataTable.vue";
import AddSiteDialog from "../spaces/AddSiteDialog.vue";
import NavBarStatus from "../workspace/NavBarStatus.vue";

const { t } = useI18n();

defineProps<{
	scope: UserScope;
	sites: Site[];
	loading?: boolean;
}>();

const emit = defineEmits<{
	add: [sites: Site[]];
}>();

const { Column } = makeColumnHelper<Site>();

const addSiteDialog = ref(false);
function openAddSiteDialog() {
	addSiteDialog.value = true;
}
</script>

<template>
	<div>
		<AppDataTable
			layout="contained"
			:data="sites"
			:loading="loading"
			:pagination="{ pageIndex: 0, pageSize: 10 }"
		>
			<template #action>
				<Button variant="outline" @click="openAddSiteDialog">{{ t("space.addSite") }}</Button>
			</template>
			<template #columns>
				<Column field="name" :header="t('common.name')" enableSorting enableGlobalFilter />
				<Column
					field="description"
					:header="t('common.description')"
					enableSorting
					enableGlobalFilter
				/>
				<Column v-slot="{ row: { original: site } }" shrink>
					<div class="flex items-center gap-1">
						<NavBarStatus class="mr-4" sourceType="site" :sourceId="site.id" />

						<slot name="action" :site="site" />
					</div>
				</Column>
			</template>
		</AppDataTable>

		<AddSiteDialog
			v-model:dialog="addSiteDialog"
			:ignores="sites.map((s) => s.id)"
			:scope="scope"
			@select="(sites) => emit('add', sites)"
		/>
	</div>
</template>
